import React, { useEffect, useState } from 'react';

import ReactModal from 'react-modal';

import closeSvg from 'src/assets/close.svg';
import { EnrollmentForm } from './enrollment-form';
import { CloseIcon, EnrollmentFormContent, EnrollmentFormContentTitle, EnrollmentFormTitle, FormTitle } from './styles';

export const EnrollmentModal: React.FC<{ isOpen: boolean }> = ({ isOpen }) => {
  const [modalIsOpen, setIsOpen] = useState<boolean>(isOpen);

  useEffect(() => {
    setIsOpen(isOpen);
  }, [isOpen]);

  const handleModal = () => {
    setIsOpen(!modalIsOpen);
  };

  return (
    <ReactModal
      isOpen={modalIsOpen}
      ariaHideApp={false}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '5px',
          margin: 'auto',
          width: '900px',
          height: '574px',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#f3f4f8',
        },
      }}
    >
      <EnrollmentFormTitle>
        <FormTitle>Open Enrollment Event Setup</FormTitle>
        <div>
          <CloseIcon src={closeSvg} onClick={handleModal} />
        </div>
      </EnrollmentFormTitle>
      <EnrollmentFormContent>
        <EnrollmentFormContentTitle>General Settings</EnrollmentFormContentTitle>

        <EnrollmentForm onClose={handleModal} />
      </EnrollmentFormContent>
    </ReactModal>
  );
};
